var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 11.5818V43.6418C23.66 43.6418 23.3 43.5818 23.02 43.4218L22.94 43.3818C19.1 41.2818 12.4 39.0818 8.06 38.5018L7.48 38.4218C5.56 38.1818 4 36.3818 4 34.4618V10.3018C4 7.92182 5.94 6.12182 8.32 6.32182C12.52 6.66182 18.88 8.78182 22.44 11.0018L22.94 11.3018C23.24 11.4818 23.62 11.5818 24 11.5818Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10.322V34.462C44 36.382 42.44 38.182 40.52 38.422L39.86 38.502C35.5 39.082 28.78 41.302 24.94 43.422C24.68 43.582 24.36 43.642 24 43.642V11.582C24.38 11.582 24.76 11.482 25.06 11.302L25.4 11.082C28.96 8.84199 35.34 6.70199 39.54 6.34199H39.66C42.04 6.14199 44 7.92199 44 10.322Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.4619H11C10.18 19.4619 9.5 18.7819 9.5 17.9619C9.5 17.1419 10.18 16.4619 11 16.4619H15.5C16.32 16.4619 17 17.1419 17 17.9619C17 18.7819 16.32 19.4619 15.5 19.4619Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.4619H11C10.18 25.4619 9.5 24.7819 9.5 23.9619C9.5 23.1419 10.18 22.4619 11 22.4619H17C17.82 22.4619 18.5 23.1419 18.5 23.9619C18.5 24.7819 17.82 25.4619 17 25.4619Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon_book.e6cfc356973bda4bdc8efb45d1542af8.svg";
export { ForwardRef as ReactComponent };